import { GridLayout } from "@arelia-components/layout/GridLayout"
import SubscriptionDetailsContainer from "../../../components/SubscriptionDetails/SubscriptionDetailsContainer";
import PaymentHistoryContainer from "../../../components/PaymentHistory/PaymentHistoryContainer";

export default function SubscriptionPresenter() {
  return <GridLayout>
    <SubscriptionDetailsContainer />
    <PaymentHistoryContainer />
  </GridLayout>;
}
